import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import foodFusionImage from '../assests/Capture.PNG';
import healthWebAppImage from '../assests/loginpage.PNG';
import portfolioWebsiteImage from '../assests/pot.PNG';

const ProjectSection = () => {
  const controls = useAnimation();

  useEffect(() => {
    const cards = document.querySelectorAll('.project-card');

    cards.forEach((card, index) => {
      card.style.transitionDelay = `${index * 100}ms`;
    });

    controls.start({
      opacity: 1,
      x: 0,
      transition: { duration: 0.5, delay: 0.2 }
    });
  }, [controls]);

  const projects = [
    {
      id: 1,
      title: 'Food Fusion Recipe App',
      description: 'Built with React, Node.js, and MongoDB. Utilizes APIs to fetch recipes.',
      image: foodFusionImage,
    },
    {
      id: 2,
      title: 'Health Web App',
      description: 'Developed with Laravel and PHPMyAdmin for database management.',
      image: healthWebAppImage,
    },
    {
      id: 3,
      title: 'Portfolio Website',
      description: 'Personal portfolio built with React to showcase projects and skills.',
      image: portfolioWebsiteImage,
    },
  ];

  return (
    <div className="container mx-auto shadow-lg rounded-md p-8">
      <section className="py-12 rounded-md" style={{ backgroundColor: '#393E46', color: 'white' }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-6">
          <motion.h2
            className="my-4 font-bold text-3xl sm:text-4xl"
            whileHover={{ scale: 1.05 }} // Hover animation
            initial={{ opacity: 0, x: -50 }} // Initial state
            animate={controls} // Animation state controlled by useAnimation
            style={{ color: 'white' }}
          >
            MY <span className="text-blue-500">Projects</span>
          </motion.h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project) => (
              <article 
                key={project.id} 
                className="relative isolate flex flex-col justify-end overflow-hidden rounded-2xl px-8 pb-8 pt-40 max-w-sm mx-auto mt-24 project-card transform transition-all duration-500 hover:scale-105"
              >
                <img 
                  src={project.image} 
                  alt={project.title} 
                  className="absolute inset-0 h-full w-full object-cover" 
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                <h3 className="z-10 mt-3 text-3xl font-bold text-white">{project.title}</h3>
                <div className="z-10 gap-y-1 overflow-hidden text-sm leading-6 text-gray-300">{project.description}</div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectSection;
